
export default abstract class Factory {

    protected components: any = {};
    protected componentClazzes: any = {};
    protected options: any;

    constructor(opts: any) {
        this.options = opts;
    }
    /**
     * 创建组件
     * @param opts {Object}
     */
    public abstract createComponents(opts: any): void;

    public getComponent(moduleid: any, compid: any) {
        if (!compid) {
            return this.components[moduleid] || null;
        } else {
            const temp = this.components[moduleid][compid];
            return temp || null;
        }

    }
}
